import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Section365DaysOfUs from "./sections/Section365DaysOfUs";
import SupportLocalSound from "./sections/SupportLocalSound";
import OurTechnologicalEcosystem from "./sections/OurTechnologicalEcosystem";
import HolisticHealthPillars from "./sections/HolisticHealthPillars";
import GlobalImpactInNumbers from "./sections/GlobalImpactInNumbers";
import EsperienzeDegliAllievi from "./sections/EsperienzeDegliAllievi";
import UnitedLifestyleFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Section365DaysOfUs />
      <SupportLocalSound />
      <OurTechnologicalEcosystem />
      <HolisticHealthPillars />
      <GlobalImpactInNumbers />
      <EsperienzeDegliAllievi />
      <UnitedLifestyleFooter />
    </div>;
}